export default "/code.c4badf68-5e8bc0.jpg";